import Button from "@mui/material/Button"; // MUI ICON COMPONENTS

import Add from "@mui/icons-material/Add";
import Remove from "@mui/icons-material/Remove"; // GLOBAL CUSTOM COMPONENTS

import { H5 } from "../../Typography";
import { FlexBetween, FlexBox } from "../../flex-box"; // ==============================================================
import SalifyFallback from "src/lib/components/salify-fallback/default";

// ==============================================================
const AddToCartButton = ({ quantity, handleDecrement, handleIncrement }) => {
  return (
    <FlexBox mt={1}>
      {quantity ? (
        <FlexBetween>
          <Button
            color="primary"
            variant="outlined"
            sx={{
              padding: "5px",
            }}
            onClick={handleIncrement}
          >
            <Add fontSize="small" />
          </Button>

          <H5 fontWeight="600" fontSize="15px" mx={1.5}>
            {quantity}
          </H5>

          <Button
            color="primary"
            variant="outlined"
            sx={{
              padding: "5px",
            }}
            onClick={handleDecrement}
          >
            <Remove fontSize="small" />
          </Button>
        </FlexBetween>
      ) : (
        <Button
          color="primary"
          variant="contained"
          sx={{
            height: 32,
          }}
          onClick={handleIncrement}
        >
          <SalifyFallback.Label path="Add To Cart" default="Thêm vào Giỏ hàng" />
        </Button>
      )}
    </FlexBox>
  );
};

export default AddToCartButton;
